// Importing necessary stylesheets and components
import "./App.scss"; // Importing custom SCSS styles
import "react-toastify/dist/ReactToastify.css"; // Importing CSS for react-toastify

import { RouterProvider } from "react-router-dom"; // Importing RouterProvider from react-router-dom
import { ToastContainer } from "react-toastify"; // Importing ToastContainer from react-toastify
import { useContext } from "react"; // Importing useContext hook from React
import router from "./Router"; // Importing router configuration

import AppContext from "./components/context/AppContext"; // Importing AppContext
import Spinner from "./components/widgets/Spinner"; // Importing Spinner component

// App component serving as the main entry point
function App() {
  // Using the useContext hook to access the loader state from AppContext
  const { loader } = useContext(AppContext);

  return (
    <>
      {/* Rendering ToastContainer to display toast notifications */}
      <ToastContainer />

      {/* Conditional rendering of Spinner component based on the loader state */}
      {loader ? <Spinner /> : ""}

      {/* Providing the router configuration to the RouterProvider */}
      <RouterProvider router={router} />
    </>
  );
}

export default App; // Exporting the App component as default